import type { CctpContextArgs, CctpSdkContext } from '@/types/sdk/experimental/cctp/cctpTypes'
import type { CctpContextResponse } from '@vaultsfyi/common/schemas'
import { parseCctpError } from './parseCctpError'

export const getCctpContext = async (
  ctx: CctpSdkContext,
  { userAddress, srcNetwork, dstNetwork, assetAddress }: CctpContextArgs
): Promise<CctpContextResponse> => {
  const response = await fetch(`${ctx.base}/cctp/context/${userAddress}/${srcNetwork}/${dstNetwork}/${assetAddress}`)

  if (!response.ok) {
    throw await parseCctpError(response, 'Failed to fetch CCTP context')
  }

  return response.json()
}
